const en = {
  switchOrg: 'Organization switch successful! Refreshing the page for you...',
  userInfo: 'Personal information',
  preferences: 'System settings',
  logout: 'Exit',
  invnManag: 'Warehouse management',
  orgHouse: 'Organization warehouse',
  orderList: 'Order list',
  invnHistory: 'Inventory history',
  salesMana: "Sales Management",
  orgManag: 'Organization management',
  customMana: "Terminal Customer Management",
  bomMana: 'BOM Management',
  priceMana: "Price Management",
  orderMana: "Order Management",
  memberManag: 'Member management',
  enableMember: 'Enable member',
  disableMember: 'Disable member',
  categoryManag: 'Product category management',
  productList: 'Product list',
  APPManagement: 'APP management',
  productData: 'Production data entry',
  orderReviews: 'Order review',
  productionInfo: 'Production Document Creation',
  dataModule: 'Data module',
  orderReport: 'Order report',
  conLogout: 'Are you sure to log out?',
  conLogoutTip1: 'You will return to the login page after confirming the logout.',
  loggingOut: 'Log out for you...',
  selectOrg: 'Please select an organization',
  themeColor: 'Theme color',
  addSuccess: 'Added successfully',
  addFailed: 'Added failed',
  updateSuccess: 'Updated successfully',
  updateFailed: 'Update failed',
  validaFailed: 'Verification failed',
  cancel: 'Cancel',
  confirm: 'OK',
  Loading: 'Loading',
  upFail: 'Upload failed',
  plTryAgain: 'Please try again later',
  changeTip: 'Language settings',
  switchOrgFailTip1: 'The current organization does not have permission to switch!',
  switchOrgFailTip2: 'Organization switch failed, please try again!',
  loginFailTip1: 'The account is not a backend administrator, please return to user login.',
  loginFailTip2: 'This account does not participate in the organization or does not have permission. Please contact the administrator.',
  userAbnormalTip: 'Abnormal user status or insufficient permissions, please contact the administrator or log in again!',
  orderProductionReports: 'Order Production Report',
  orderReview: 'Order review',
  orderProductionData: 'Order Production Data',
  purchaseMana: 'Procurement Management',
  supplierMana: 'Supplier Management',
  materialControl: 'Material Control Management',
  requirementList: 'List of Requirements',
  noPassRequirement: 'Unapproved demand list',
  passedRequirement: 'Approved Requirements List',
  prod: 'Production Management',
  finance: 'Financial Management',
  generatePurOrder: 'Generate purchase order',
  isAdmin: 'System Administrator',

  okOrder: 'Selling Official Orders',
  saleOrderFinish: 'Sales Order Completion',
  waitOk: 'Requirement Review',
  noPass: 'Review Pending Processing',
  passed: 'Requirement has been reviewed',
  purOrder: 'Purchase Order Management',
  orderRe: 'Sales Review Form',
  disableAndEnable: 'Disable And Enable',
  memberOperation: 'Member operation',
  commodityEditor: 'Commodity editor',
  subcategoryEditing: 'Subcategory editing',
  orgOperation: 'Organizational operation',
  reject: 'Demand Return',
  orgMana: "Organization Management",
  orgInfoUpdate: "Organization Information Modification",
  orgMemberUpdate: "Organization Member Modification",
  wareMana: "Warehouse Management",
  inboundMana: "Inbound Management",
  outboundMana: "Outbound Management",
  inventoryMana: "Inventory Management",
  orderTrack: 'Order tracking',
  pendingOrder: 'Unfinished',
  doneOrder: 'Completed',
  closeOrder: 'Closed',
  mcDataMt: 'Maintenance of Material Control Data',
  mcReTemp: 'Material Control Requirement Template',
  orderEntry: 'Order data entry',
  orderProdMt: 'Production data maintenance',
  purPendingPay: 'Not ordered',
  purPayed: 'Ordered',
  purDone: 'Completed',
  purOrderMt: 'Procurement Information Maintenance',
  requirementPurchase: 'Purchase Order Creation',
  reqM: 'Material Preparation Plan',
  DATAManage: 'Data Management',
  QutationManage: 'Inquiry Form Management',
  typeManage: 'Product Type Management',
  submit: 'Save',
  gategoryManage: 'List of quoted products',
  printSetting: 'Print Settings',
  quotationManage: 'Quotation Management',
  setExchange: 'Set exchange rate',
  mainCurrency: 'Standard money',
  company: 'Company Name',
  address: 'Company Address',
  plzCompany: 'Please enter the company name',
  plzAddress: 'Please enter the company address',
  orderManage: 'Order Management',
  warehousePreparation: 'Inbound/Outbound Preparation',
  warehouseManagement: 'Inbound/Outbound Management',
  operationStatus: 'Operation Status',
  locationManagement: 'Location Management',
  commodity: 'Product Management',
  upSucc: "File upload succeeded",
  addressM: "Delivery Address Management",
  addAddress: "Add Address",
  editAddress: "Edit Address",
  inventoryManage: "Inventory Management",

  // New translation keys
  purchaseOperation: 'Purchase Operation',
  manualQuotation: 'Manual Quotation',
  materialTracking: 'Material Tracking',
  returnAndExchange: 'Return & Exchange',
  pleaseFillRate: 'Please fill in the exchange rate',
  uploadImage: 'Upload Image',
  pleaseEnterName: 'Please enter name',
  pleaseEnterAddress: 'Please enter address',
  orderReportAll: 'Order Report_All',

  // Supplier management
  disabledSupplier: 'Disabled Suppliers',
  confirmDisableSupplier: 'Confirm to disable?',
  confirmDisableSupplierDesc: 'This will disable this supplier',
  confirmEnableSupplier: 'Confirm to enable?',
  confirmEnableSupplierDesc: 'This will enable this supplier',

  // Reimburse
  reimburseCategory: 'Reimburse Category',
  approveTemplate: 'Approve Template',
  reimburseMana: 'Application Approval',
  myApplication: 'My Applications',
  pendingApproval: 'Pending My Approval',
  allApplications: 'All Applications',
  inOutDetail: 'In/Out Detail',
  locationRefProducts: 'Location Product Relation',
  priceList: "Purchase Price List",
  inventoryAlert: "Inventory Alert",
  setInventoryAlert: "Add Inventory Alert",
  purchaseRule: "Purchase Terms",
  addPurchaseRule: "Add Purchase Terms",
  ruleLangsPl: "Please select the language version of the purchase terms to add (if your desired language is not available, please go to system settings to add it)",
  printRule: "Add Terms",
  notPrintRule: "Do Not Add Terms",
  noRuleConfig: "No purchase terms have been filled in for any language. To print purchase terms, please go to system settings to complete them.",
  purchaseRuleSet: "Purchase Terms Settings",
  factoryInventory: "Production Line Warehouse",
  equipmentManagement: "Equipment Management",
  width: "Paper Width (Vertical Continuous)",
  height: "Paper Height (Vertical Continuous)",
  printTip: "System printing paper settings: {{width}}mm X {{height}}mm",
  printTipVertical: "Vertical continuous printing paper settings (Width X Height)",
  purInvItem: "Delivery Note Details",
  locInvDetail: "Location In/Out Details",
};

export default en;
